export class LanguageDetail {
    public Id: number;
    public Name = '';
    public Updated: Date;

}
